import type { ApprovePromotionRequest } from '@library/types/promotions';
import { ConfirmationModal } from '@library/components/modals/ConfirmationModal';

type ApprovePromotionModalProps = {
  isOpen: boolean;
  onCancelModal: () => void;
  onConfirm: (approveReq: ApprovePromotionRequest) => void;
  memberCount: string;
  payoutAmount: string;
  promotionId: number;
  isLoading: boolean;
};

export const ApprovePromotionModal = ({
  isOpen,
  onCancelModal,
  onConfirm,
  memberCount,
  payoutAmount,
  promotionId,
  isLoading
}: ApprovePromotionModalProps) => {
  const handleConfirm = () => {
    onConfirm({
      promotionId
    });
  };

  return (
    <ConfirmationModal
      isOpen={isOpen}
      confirmationCopy="Approve"
      onCancelModal={onCancelModal}
      handleConfirm={handleConfirm}
      label="Are you sure?"
      isLoading={isLoading}
    >
      <p>
        {payoutAmount !== '-'
          ? `You're about to approve a promotion for ${memberCount} eligible users with a potential max payout of ${payoutAmount}.`
          : `You're about to approve a promotion for ${memberCount} eligible users.`}
      </p>
    </ConfirmationModal>
  );
};
